import { render, staticRenderFns } from "./WideOtherData.vue?vue&type=template&id=247c3b39&scoped=true&"
import script from "./WideOtherData.vue?vue&type=script&lang=js&"
export * from "./WideOtherData.vue?vue&type=script&lang=js&"
import style0 from "./WideOtherData.vue?vue&type=style&index=0&id=247c3b39&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "247c3b39",
  null
  
)

export default component.exports